import { QueryClient, useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { refetchArticle } from "../../../api/articles";
import { V3GenericErrorHandler } from "../../../api/error-handler";
import { Queries, getItemQuerie } from "../../../types/queries";

// Refetch (re-import) an article that's already in the account
export const getRefetchArticleMutation = (queryClient: QueryClient, token: string) =>
    useMutation({
        mutationFn: refetchArticle,
        onError: V3GenericErrorHandler(toast.error),
        onSuccess: (_, variables) => {
            // The re-import runs in a worker, so we can't update the item optimistically - we just drop the stale data
            queryClient.invalidateQueries({ queryKey: getItemQuerie(token, variables.articleSlug) });
            queryClient.invalidateQueries({ queryKey: [Queries.Content] });
            queryClient.invalidateQueries({ queryKey: [Queries.ContentAnalytics] });
            queryClient.invalidateQueries({ queryKey: [Queries.Collections] });
        }
    });
